import { render, staticRenderFns } from "./ReportsNav.component.vue?vue&type=template&id=e54e0e90&scoped=true&"
import script from "./ReportsNav.component.vue?vue&type=script&lang=ts&"
export * from "./ReportsNav.component.vue?vue&type=script&lang=ts&"
import style0 from "./ReportsNav.component.vue?vue&type=style&index=0&id=e54e0e90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54e0e90",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
